import { message } from 'antd';
import axios from 'axios';
import { sharedRead, invalidateSharedReads, invalidateSharedReadsWithPrefix } from './sharedReadCache';

// 创建一个axios实例 除了登陆用axios 其他之外的都用这个apiClient，统一校验token是否存在
const apiClient = axios.create({
  baseURL: '/api', // 这里设置基础路径
  timeout: 20000,
});

// 添加请求拦截器
apiClient.interceptors.request.use((config) => {

  const token = localStorage.getItem("token");
  if (token) {
    config.headers['Authorization'] = `${token}`;

    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    } else {
      config.headers['Content-Type'] = 'application/json';
    }
  } else {
    delete config.headers['Authorization'];
    window.dispatchEvent(new CustomEvent('auth:logout'));
  }

  return config;
});

// 添加响应拦截器
apiClient.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      const path = (response.config?.url || '').split('?')[0];
      const method = (response.config?.method || 'get').toLowerCase();
      if (method !== 'get' && Number(response.data?.code) === 200) {
        if (/^\/message-notifications\/(mark-all-read|[^/]+\/(read|solve))$/.test(path)) {
          invalidateSharedReads('/message-notifications/my');
          window.dispatchEvent(new CustomEvent('notifications:changed'));
        }
        if (path.startsWith('/prime/auth/')) invalidateSharedReads('/prime/auth/op-info-list');
        const shippingRead = /^\/shipping-order\/(query(?:\/advanced)?|export-excel(?:\/advanced)?|external\/(query|carrier-info)|emails|generate-pdf|release\/validate|field-index\/query)$/.test(path);
        if (path.startsWith('/shipping-order/') && !shippingRead) {
          invalidateSharedReadsWithPrefix('/shipping-order/');
          invalidateSharedReads('/message-notifications/my');
        }
      }
      return response;
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    // Preview renders its own error/retry state; keep global login expiry handling.
    if (error.config?.previewErrorHandled && error.response?.status !== 401) return Promise.reject(error);
    if (error.response) {
      switch (error.response.status) {
        case 400:
          message.error('Error:' + error.response);
          break;
        case 401:
          localStorage.removeItem("token");
          localStorage.removeItem('userInfo');
          localStorage.setItem('userStatus', 'logout');

          window.dispatchEvent(new CustomEvent('auth:logout'));
          break;
        case 403:
          message.error('您没有权限访问此资源！');
          break;
        default:
          message.error('Error:' + error.response);
      }
    } else if (error.request) {
      console.error('No response received:', error.request);
    } else {
      console.error('Error setting up request:', error.message);
    }
    return Promise.reject(error);
  }
);


export default apiClient;

export const getOpInfoList = () => sharedRead('/prime/auth/op-info-list',
  () => apiClient.get('/prime/auth/op-info-list'), 5 * 60 * 1000);

export const getMyNotifications = () => sharedRead('/message-notifications/my',
  () => apiClient.get('/message-notifications/my'), 5000);

export const getAttachmentList = (path, refresh = false) => {
  if (refresh) invalidateSharedReads(path);
  return sharedRead(path, () => apiClient.get(path), 30000);
};
